export enum PaymentMode {
    Check = 0,
    CreditCard = 1,
    FreeAct = 2,
    Moneo = 3,
    Cash = 4,
    Transfer = 5,
    Other = 6,
    Waiting = 7
}